import { render, staticRenderFns } from "./ChangeRoleDialog.vue?vue&type=template&id=cec4fcfa&scoped=true&lang=pug&"
import script from "./ChangeRoleDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeRoleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeRoleDialog.vue?vue&type=style&index=0&id=cec4fcfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec4fcfa",
  null
  
)

export default component.exports